// import React from "react";

// interface TakaStickerProps {
//   fabricId: string;
//   cn: string;
//   date: string;
//   designNo: string;
//   meters: string;
//   totalTaka: string;
//   size: string;
//   pattern: string;
// }

// const TakaSticker = React.forwardRef<HTMLDivElement, TakaStickerProps>(
//   ({ fabricId, cn, date, designNo, meters, totalTaka, size, pattern }, ref) => {
//     return (
//       <div ref={ref} id="sticker-container" style={styles.sticker}>
//         {/* Top Row */}
//         <div style={styles.topRow}>
//           <span style={styles.topText}>Fabric: {fabricId}</span>
//           <span style={styles.topText}>C.N.: {cn}</span>
//           <span style={styles.topText}>{date}</span>
//         </div>

//         {/* Divider */}
//         <div style={styles.divider}></div>

//         {/* Main Info */}
//         <div style={styles.mainInfo}>
//           <p style={styles.infoItem}>
//             Design No. <span style={styles.dots}>:</span>{" "}
//             <span style={styles.boldValue}>{designNo}</span>
//           </p>
//           <p style={styles.infoItem}>
//             Mtrs <span style={styles.dots}>:</span>{" "}
//             <span style={styles.boldValue}>{meters}</span>
//           </p>
//           <p style={styles.infoItem}>
//             Total Taka <span style={styles.dots}>:</span>{" "}
//             <span style={styles.boldValue}>{totalTaka}</span>
//           </p>
//           <p style={styles.infoItem}>
//             Size <span style={styles.dots}>:</span>{" "}
//             <span style={styles.boldValue}>{size}</span>
//           </p>
//           <p style={styles.infoItem}>
//             Pattern <span style={styles.dots}>:</span>{" "}
//             <span style={styles.boldValue}>{pattern}</span>
//           </p>
//         </div>
//       </div>
//     );
//   }
// );

// const styles: { [key: string]: React.CSSProperties } = {
//   sticker: {
//     fontFamily: "'Segoe UI', Arial, sans-serif",
//     backgroundColor: "white",
//     padding: "18px 22px",
//     width: "400px",
//     color: "#000",
//     border: "1px solid #dcdcdc",
//     boxShadow: "0 0 2px rgba(0,0,0,0.1)",
//     lineHeight: "1.6",
//   },
//   topRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     marginBottom: "6px",
//   },
//   topText: {
//     fontSize: "15px",
//     fontWeight: 500,
//   },
//   divider: {
//     height: "1px",
//     backgroundColor: "#dcdcdc",
//     marginBottom: "10px",
//   },
//   mainInfo: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "0px",
//     marginLeft:"120px"
//   },
//   infoItem: {
//     fontSize: "17px",
//     margin: 0,
//     display: "flex",
//     alignItems: "center",
//   },
//   dots: {
//     display: "inline-block",
//     width: "12px",
//   },
//   boldValue: {
//     fontWeight: 600,
//     marginLeft: "4px",
//   },
// };

// export default TakaSticker;

import React from "react";

interface TakaStickerProps {
  fabricId: string;
  cn: string;
  date: string;
  designNo: string;
  meters: string;
  totalTaka: string;
  size: string;
  pattern: string;
}

const TakaSticker = React.forwardRef<HTMLDivElement, TakaStickerProps>(
  ({ fabricId, cn, date, designNo, meters, totalTaka, size, pattern }, ref) => {
    // Cleanly split the size string into segments
    const sizeSegments = size
      .split("/")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    return (
      <div ref={ref} id="sticker-container" style={styles.sticker}>
        {/* Top Row */}
        <div style={styles.topRow}>
          <span style={styles.topText}>Fabric: {fabricId}</span>
          <span style={styles.topText}>C.N.: {cn}</span>
          <span style={styles.topText}>{date}</span>
        </div>

        <div style={styles.divider}></div>

        {/* Main Info */}
        <div style={styles.mainInfo}>
          <p style={styles.infoItem}>
            Design No.: <span style={styles.boldValue}>{designNo}</span>
          </p>
          <p style={styles.infoItem}>
            Mtrs: <span style={styles.boldValue}>{meters}</span>
          </p>
          <p style={styles.infoItem}>
            Total Taka: <span style={styles.boldValue}>{totalTaka}</span>
          </p>

          {/* Size Section */}
          <div style={{ marginTop: "8px", textAlign: "center" }}>
            <p style={{ fontSize: "16px", marginBottom: "6px" }}>Size Segments:</p>
            <div style={styles.sizeContainer}>
              {sizeSegments.map((seg, i) => (
                <div key={i} style={styles.sizeBox}>
                  {seg}
                </div>
              ))}
            </div>
          </div>

          <p style={{ ...styles.infoItem, marginTop: "10px" }}>
            Pattern: <span style={styles.boldValue}>{pattern}</span>
          </p>
        </div>
      </div>
    );
  }
);

const styles: { [key: string]: React.CSSProperties } = {
  sticker: {
    fontFamily: "'Segoe UI', Arial, sans-serif",
    backgroundColor: "#fff",
    padding: "18px 22px",
    width: "420px",
    color: "#000",
    border: "1px solid #dcdcdc",
    boxShadow: "0 0 4px rgba(0,0,0,0.1)",
    lineHeight: "1.6",
    textAlign: "center",
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "15px",
    fontWeight: 500,
    marginBottom: "8px",
  },
  topText: {
    fontSize: "15px",
    fontWeight: 500,
  },
  divider: {
    height: "1px",
    backgroundColor: "#dcdcdc",
    marginBottom: "12px",
  },
  mainInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
  },
  infoItem: {
    fontSize: "17px",
    margin: "0",
  },
  boldValue: {
    fontWeight: 600,
    marginLeft: "4px",
  },
  sizeContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
  },
  sizeBox: {
    border: "1px solid #dcdcdc",
    borderRadius: "8px",
    padding: "6px 14px",
    fontWeight: 600,
    fontSize: "15px",
    backgroundColor: "#f9f9f9",
    whiteSpace: "nowrap", // ensures the text stays in one line
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "70px", // ensures consistent box size
  },
};

export default TakaSticker;
